import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

export interface FilterValue {
  _id: string;
  label: string;
}

export interface Filter {
  _id: string;
  label: string;
  isActive: boolean;
  isSystem: boolean;
  values: FilterValue[];
  filterKey?: string;
}

export interface AssetLibraryFilterState {
  filters: Filter[];
  loading: boolean;
  error: string | null;
  activePanel: string | null;
}

const AssetLibraryFilterTypes = {
  FETCH_FILTERS_SUCCESS: 'ASSET_LIBRARY_FETCH_FILTERS_SUCCESS',
  UPDATE_FILTER_LABEL: 'ASSET_LIBRARY_UPDATE_FILTER_LABEL',
  TOGGLE_FILTER_ACTIVE: 'ASSET_LIBRARY_TOGGLE_FILTER_ACTIVE',
  ADD_VALUE: 'ASSET_LIBRARY_ADD_VALUE',
  EDIT_VALUE: 'ASSET_LIBRARY_EDIT_VALUE',
  DELETE_VALUE: 'ASSET_LIBRARY_DELETE_VALUE',
  SET_LOADING: 'ASSET_LIBRARY_SET_LOADING',
  SET_ERROR: 'ASSET_LIBRARY_SET_ERROR',
  SET_ACTIVE_PANEL: 'ASSET_LIBRARY_SET_ACTIVE_PANEL',
  ADD_FILTER_TYPE: 'ASSET_LIBRARY_ADD_FILTER_TYPE',
  DELETE_FILTER_TYPE: 'ASSET_LIBRARY_DELETE_FILTER_TYPE',
} as const;

export type AssetLibraryFilterTypeKey = keyof typeof AssetLibraryFilterTypes;
export type AssetLibraryFilterTypeValue =
  (typeof AssetLibraryFilterTypes)[AssetLibraryFilterTypeKey];

export type AssetLibraryDispatch = ThunkDispatch<unknown, unknown, AnyAction>;

export default AssetLibraryFilterTypes;
